import { useNavigate } from "react-router-dom";

import { Models, OrderPickupStatus } from "api/types";
import { getPickupProgress } from "utils/retailProducts.helpers";

import { RetailProductPickupSection } from "../index";

export interface RetailProductEarnedSectionProps {
  earnedProducts: Models<"DisplayRetailProductOrderLineItemForPickup">[];
  platformLocations: Models<"PlatformLocationModel1">[];
}

export const RetailProductEarnedSection = ({
  earnedProducts,
  platformLocations,
}: RetailProductEarnedSectionProps) => {
  const navigate = useNavigate();

  // Filter out redeemed products - only show available (not picked up) earned products
  const availableEarnedProducts = earnedProducts.filter(
    (product) => product.status !== OrderPickupStatus.PickedUp
  );

  if (availableEarnedProducts.length === 0) return null;

  return (
    <>
      <div className="grid grid-cols-1 gap-4">
        {availableEarnedProducts.map((earnedProduct) => {
          // For earned products, we don't have locationId at the line item level
          // We'll use the first available location or a default
          const locationName =
            platformLocations.length > 0 ? platformLocations[0].name : "Store";

          const pickupProgress = getPickupProgress([earnedProduct]);

          return (
            <div
              key={earnedProduct.packageId}
              className="cursor-pointer overflow-hidden rounded-lg border bg-white shadow-sm transition-all duration-200 hover:shadow-md active:scale-[0.98]"
              onClick={() =>
                navigate(
                  `/wallet/products/earned/${earnedProduct.packageId}?type=earned`
                )
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  navigate(
                    `/wallet/products/earned/${earnedProduct.packageId}?type=earned`
                  );
                }
              }}
              role="button"
              tabIndex={0}
            >
              <div className="p-4">
                <RetailProductPickupSection
                  context="wallet"
                  pickupItems={[earnedProduct]}
                  pickupProgress={pickupProgress}
                  locationName={locationName}
                  orderType="earned"
                />
              </div>
              <div className="w-full bg-brand-color/10 py-2 text-center text-body3 text-brand-color">
                View Details
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
